export default __webpack_public_path__ + "static/media/carrotjuice.0621f4df.png";